import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const settingsPanelPickerStyleId = 'wb-v2-settings-panel-picker-theme';

export const settingsPanelPickerBridgeStyles = {
  'settings-panel-picker': {
    '--local-divider-color': tokens.color.border.secondary,
    '--local-border-secondary': tokens.color.border.secondary,
    '--local-text-tertiary': tokens.color.text.tertiary,
    '--local-text-quaternary': tokens.color.text.quaternary,
    '--local-text-primary': tokens.color.text.primary,
    '--local-bg-primary': tokens.color.background.primary,
    '--local-bg-secondary': tokens.color.background.tertiary,
    '--local-bg-primary-hover': tokens.color.background.primaryHover,
    // Active-descendant highlight — distinctly more present than hover.
    '--local-bg-active': tokens.color.background.tertiary,
    '--local-foreground-secondary': tokens.color.foreground.secondary,
    '--local-focus-ring': tokens.color.border.brand,
    '--local-focus-ring-soft': 'rgba(219, 234, 254, 0.6)',
    '--local-spacing-xs': tokens.spacing.xs,
    '--local-spacing-sm': tokens.spacing.sm,
    '--local-spacing-md': tokens.spacing.md,
    '--local-spacing-lg': tokens.spacing.lg,
    '--local-radius-sm': tokens.radius.sm,
    '--local-font-family-body': tokens.font.family.body,
    '--local-font-size-text-xs': tokens.font.size.textXs,
    '--local-font-size-text-sm': tokens.font.size.textSm,
    '--local-font-size-text-md-base': tokens.font.size.textMdBase,
    '--local-font-weight-regular': tokens.font.weight.regular,
    '--local-font-weight-semibold': tokens.font.weight.semibold,
    '--local-font-weight-medium': tokens.font.weight.medium,
    '--local-line-height-text-xs': tokens.lineHeight.textXs,
    '--local-line-height-text-sm': tokens.lineHeight.textSm,
    '--local-line-height-text-md': tokens.lineHeight.textMd,
  },
};